import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import Sidebar from './Sidebar';
import { authService } from '../../services/authService';

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const isAuthenticated = authService.isAuthenticated();
  const isLoginPage = location.pathname === '/login';

  return (
    <div className="min-h-screen flex flex-col overflow-x-hidden bg-background text-foreground">
      <Header onMenuToggle={() => setSidebarOpen(!sidebarOpen)} />
      {/* Spacer so content starts below fixed header (header is h-16) */}
      <div className="h-16 flex-shrink-0" aria-hidden="true" />
      {/* flex-1 so short pages still push footer down; no min-h-0 so content can grow and page scrolls */}
      <div className="flex flex-1 flex-col lg:flex-row min-h-0">
        {isAuthenticated && !isLoginPage && (
          <Sidebar isOpen={sidebarOpen} onToggle={() => setSidebarOpen(!sidebarOpen)} />
        )}
        <main
          className={`flex-1 min-w-0 transition-all duration-300 flex flex-col min-h-0 ${isAuthenticated && !isLoginPage ? 'lg:ml-0' : ''} ${isLoginPage ? 'p-0' : ''}`}
        >
          {children}
        </main>
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
